import React from 'react'
import propTypes from 'prop-types'
import {isEmpty} from 'lodash'
import ActionLink, {LINK_TYPE} from 'components/actionLink'

const ActionPhoneLink = (props) => {
  const {value, category} = props
  return isEmpty(value)
      ? null
      : <ActionLink
          className={'phone-number'}
          category={category}
          action={'Phone Link'}
          label={'Clicked on a phone number'}
          type={LINK_TYPE.PHONE}
          href={`tel:${value}`}
          title={value}/>
}

ActionPhoneLink.propTypes = {
  value: propTypes.any,
  category: propTypes.string.isRequired,
}

export default ActionPhoneLink
